module.exports = __webpack_public_path__ + "static/img/luxclear.8d9517c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/agc/items/luxclear/luxclear.jpg
// module id = 525
// module chunks = 0